import React, { Suspense, useState } from "react"
import { useStore } from "react-reducer-store"
import CssBaseline from "@material-ui/core/CssBaseline"
import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"
import useStyles from "./styles/privateCss"
import Header from "../components/Header"
import Loading from "../components/Loading"
import DialogBoxSession from "../components/DialogBoxSession"
import AuthenticationUtil from "../utils/AuthenticationUtil"
import { GRAPH_URL, AUTH_URL, APP_NAME } from "../../../constants"
import { AppActions } from "../../../store/actions"
import LeftNav from "../components/LeftNav"
import Notification from "../components/Notification"

const PrivateLayout = props => {
  const { Component, ParentComponent, userCompanies, isPlain } = props
  const { isAuthenticated } = AuthenticationUtil
  const classes = useStyles(props)
  const [showLeftNav, setShowLeftNav] = useState(false)
  const user = JSON.parse(localStorage.getItem("user"))

  const appActions = AppActions()
  const appStore = useStore(state => state.app)

  const handleShowLeftNav = () => setShowLeftNav(true)
  const handleHideLeftNav = () => setShowLeftNav(false)

  const { location } = window;

  if (!isAuthenticated()) {
    const cbUrl = location.href
    const url = `${AUTH_URL}/?cbUrl=${cbUrl}&appName=${APP_NAME}`
    location.href = url
    console.log("Redirecting to login page", url)
    return true
  }

  const storedCompany = localStorage.getItem("OMNI_SELECTED_COMPANY")
  const storedApp = localStorage.getItem("OMNI_SELECTED_APP")

  if (!storedCompany && !storedApp) {
    const firstCompany = userCompanies[0]
    const firstAppID = user.authorizations.find(
      auth => auth.companyName === firstCompany,
    ).app
    const firstCompanyId = user.authorizations.find(
      auth => auth.companyName === firstCompany,
    )._id

    localStorage.setItem("OMNI_SELECTED_COMPANY", firstCompany)
    localStorage.setItem("OMNI_SELECTED_APP", firstAppID)
    localStorage.setItem("OMNI_SELECTED_COMPANY_ID", firstCompanyId)

    appActions.setAppId(firstAppID)
  }



  if (isPlain) {
    return (
      <div className={classes.root}>
        <CssBaseline />
        <Suspense fallback={<Loading />}>
          <Component {...props} user={user} />
        </Suspense>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <CssBaseline />

      <DialogBoxSession
        graphBaseUrl={GRAPH_URL}
        AuthenticationUtil={AuthenticationUtil}
        AppActions={AppActions}
      />

      <Notification
        open={appStore ? appStore.showNotification : false}
        message={appStore ? appStore.message : ""}
      />

      <Suspense fallback={<Loading />}>
        <Header {...props} user={user} handleShowLeftNav={handleShowLeftNav} />
      </Suspense>

      <LeftNav
        {...props}
        user={user}
        showLeftNav={showLeftNav}
        handleHideLeftNav={handleHideLeftNav}
      />

      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth={false} className={classes.container}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Suspense fallback={<Loading />}>
                <Component {...props} user={user} />
              </Suspense>
            </Grid>
          </Grid>
        </Container>
      </main>
      {/* <Hidden only="xs">
        <Footer />
      </Hidden> */}
    </div>
  )
}

export default PrivateLayout
